import LoadingButton from "@mui/lab/LoadingButton";
import * as Yup from "yup";
import { useFormik } from "formik";
import {
  AppBar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import { useMutation } from "@tanstack/react-query";
import { handleSendMessage } from "../../utilities";
import { useAuth } from "../../context/auth";
import { useNotifications } from "@toolpad/core/useNotifications";
import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useState } from "react";
import AgreementForm from "./components/agreement-form";
import { TransitionProps } from "@mui/material/transitions";
import { IAgreementService } from "src/interface/IAgreementService";
import { IAutoCompleteLabelValue } from "src/interface/enum/GeneralType";

import { IAgreement } from "src/interface/IAgreement";
import { getRoutes } from "src/utilities/routes";
import SkeltonProgress from "src/components/SkeltonProgress";
import { IBaseAgreement } from "src/interface/IBaseAgreements";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const validationSchema = Yup.object({
  customerRef: Yup.string().required("این فیلد الزامی است"),
  price: Yup.string().required("این فیلد الزامی است"),
  delayFactor: Yup.string().required("این فیلد الزامی است"),
  sessionCounter: Yup.string().required("این فیلد الزامی است"),
  startedAt: Yup.string().required("این فیلد الزامی است"),
});

const initialValues: IAgreement = {
  customerRef: "",
  creatorRef: undefined,
  startedAt: new Date(),
  delayFactor: 1,
  price: 0,
  sessionCounter: 0,
  baseAgreementActivityRef: undefined,
  baseAgreementServiceRef: undefined,
};
interface NewAgreementProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  refetch: any;
  customers: IAutoCompleteLabelValue[];
  isEdit?: boolean;
  agreementId?: number;
  setAgreementId?: (agreementId?: number) => void;
}
const NewAgreement = ({
  open,
  setOpen,
  refetch,
  customers,
  isEdit = false,
  agreementId,
  setAgreementId,
}: NewAgreementProps) => {
  const Routes = getRoutes();
  const [agreementServices, setAgreementServices] = useState<
    IAgreementService[]
  >([]);
  const [existingAgreementServices, setExistingAgreementServices] = useState<
    IAgreementService[]
  >([]);
  const [baseAgreements, setBaseAgreements] = useState<IBaseAgreement[]>([]);
  const handleClose = () => {
    setOpen(false);
    formik.resetForm();
    setExistingAgreementServices([]);
    setAgreementId && setAgreementId(undefined);
    setAgreementServices([]);
    setBaseAgreements([]);
  };
  const { user } = useAuth();
  const { mutateAsync: insertAsync, isPending } = useMutation({
    mutationFn: async (body: any) => {
      const response = await fetch(Routes.AgreementsRoutes, {
        method: "POST",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const { mutateAsync: updateAsync, isPending: isPendingEdit } = useMutation({
    mutationFn: async (body: IAgreement) => {
      const response = await fetch(Routes.AgreementsRoutes + body.id, {
        method: "Put",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      console.log(error);
    },
  });
  const {
    mutateAsync: insertAgreeServiceAsync,
    isPending: isPendingAgreeServic,
  } = useMutation({
    mutationFn: async (body: any) => {
      const response = await fetch(Routes.AgreementServicesRoutes, {
        method: "POST",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const {
    mutateAsync: updateAgreeServiceAsync,
    isPending: isPendingAgreeServiceEdit,
  } = useMutation({
    mutationFn: async (body: IAgreementService) => {
      const response = await fetch(Routes.AgreementServicesRoutes + body.id, {
        method: "Put",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      console.log(error);
    },
  });
  const { mutateAsync: deleteAgreeServiceAsync, isPending: isDeleteLoading } =
    useMutation({
      mutationFn: async (agreementServiceId: string) => {
        const response = await fetch(
          Routes.AgreementServicesRoutes + agreementServiceId,
          {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${user?.token}`,
              Aceept: "application/json",
            },
          }
        );
        return await response.json();
      },
      onSuccess: (responseData) => {
        JSON.stringify(responseData);
      },
      onError: (error) => {
        notifications.show("خطا در دریافت اطلاعات", {
          severity: "error",
          autoHideDuration: 3000,
        });
        console.log(error);
      },
    });
  const notifications = useNotifications();

  const formik = useFormik<IAgreement>({
    initialValues, // مقادیر اولیه فرم
    validationSchema, // schema اعتبارسنجی
    onSubmit: async (values) => {
      let isValid = true;
      agreementServices.map((row) => {
        if (row.selected) {
          if (
            row.service?.followUpGroups &&
            row.service?.followUpGroups?.length > 0
          ) {
            if (row.followUpGroupRef === 0 || !row.followUpGroupRef) {
              handleSendMessage(
                notifications,
                "برای '" + row.service.name + "' یک 'گروه پیگیری' انتخاب کنید",
                "error",
                2000,
                row.service?.id?.toString()
              );
              isValid = false;
            }
          }
          if (!row.serviceItemByTypeRef) {
            handleSendMessage(
              notifications,
              "برای '" + row.service?.name + "' یک 'نوع' انتخاب کنید",
              "error",
              2000,
              row.service?.id?.toString()
            );
            isValid = false;
          }
          if (!row.serviceItemByVolumeRef) {
            handleSendMessage(
              notifications,
              "برای '" + row.service?.name + "' یک 'حجم' انتخاب کنید",
              "error",
              2000,
              row.service?.id + "(1)"?.toString()
            );
            isValid = false;
          }
        }
      });
      if (!isValid) {
        return;
      }
      let res: any;
      if (isEdit && agreementId) {
        res = await updateAsync({
          ...values,
          startedAt: values.startedAt && new Date(values.startedAt),
        });
      } else {
        res = await insertAsync({
          ...values,
          startedAt: values.startedAt && new Date(values.startedAt),
        });
      }

      if (res.status) {
        agreementServices.map(async (row) => {
          if (row.selected) {
            if (
              isEdit &&
              existingAgreementServices.find((x) => x.id === row.id)
            ) {
              await updateAgreeServiceAsync({
                ...row,
                followUpGroupRef:
                  row.followUpGroupRef === 0 ? undefined : row.followUpGroupRef,
              });
            } else {
              await insertAgreeServiceAsync({
                ...row,
                agreementRef: res?.data?.id,
                followUpGroupRef:
                  row.followUpGroupRef === 0 ? undefined : row.followUpGroupRef,
              });
            }
          } else {
            if (
              row &&
              row.id &&
              existingAgreementServices.find((x) => x.id === row.id)
            ) {
              await deleteAgreeServiceAsync(row.id.toString());
            }
          }
        });

        notifications.show("قرارداد جدید با موفقیت ثبت شد!", {
          key: "new-agreement",
          severity: "success",
          autoHideDuration: 5000,
        });

        refetch();
        setAgreementId && setAgreementId(undefined);

        handleClose();
      } else {
        notifications.show("خطا در ذخیره سازی!", {
          key: "err-agreement",
          severity: "error",
          autoHideDuration: 5000,
        });
      }
      formik.resetForm();
    },
  });
  // console.log(formik.values);

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (isEdit && agreementId) {
      async function fetchData() {
        setLoading(true);
        const response = await fetch(Routes.AgreementsRoutes + agreementId, {
          method: "GET",
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json-patch+json",
            Authorization: `Bearer ${user?.token}`,
          },
        });

        const data = await response.json();
        console.log("🚀 ~ fetchData ~ data:", data);
        formik.setValues(data);
        if (data.services && data.services.length > 0)
          setExistingAgreementServices(data.services);
        setLoading(false);
      }
      fetchData();
    }
  }, [isEdit, agreementId]);

  // React.useEffect(() => {
  //   async function fetchData() {
  //     if (formik.values.startedAt) {
  //       const sessionCounter = remainingSeasonsInPersianYear(
  //         formik.values.startedAt || new Date()
  //       );
  //       if (agreementServices.length > 0) {
  //         const updatedRows = agreementServices.map((item: any) => ({
  //           ...item,
  //           count: sessionCounter * 3,
  //         }));
  //         console.log("🚀 ~ updatedRows ~ updatedRows:", updatedRows);

  //         //await setAgreementServices([]); // اطمینان از تغییر مرجع
  //         await setAgreementServices(updatedRows); // اطمینان از تغییر مرجع
  //       }
  //     }
  //   }
  //   fetchData();
  // }, [formik.values.startedAt]);

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        fullScreen
        TransitionComponent={Transition}
        PaperProps={{
          component: "form",
          onSubmit: formik.handleSubmit,
        }}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {isEdit ? "ویرایش قرارداد " : "قرارداد جدید"}
            </Typography>
          </Toolbar>
        </AppBar>

        <DialogContent>
          <AgreementForm
            customers={customers}
            baseAgreements={baseAgreements}
            setBaseAgreements={setBaseAgreements}
            formik={formik}
            key={"tess"}
            agreementServices={agreementServices}
            setAgreementServices={setAgreementServices}
            existingAgreementServices={existingAgreementServices}
            isEdit={isEdit}
            existingServiceLoading={loading}
          />
        </DialogContent>
        <DialogActions>
          <LoadingButton
            loading={
              isPending ||
              isPendingAgreeServic ||
              isPendingEdit ||
              isPendingAgreeServiceEdit
            }
            variant="contained"
            color="success"
            size="medium"
            fullWidth
            type="submit"
          >
            ذخیره
          </LoadingButton>
          <Button color="error" variant="contained" onClick={handleClose}>
            انصراف
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default NewAgreement;
